import {inject} from '@angular/core';
import {NavigationError} from '@angular/router';
import {WindowProvider} from './window-provider';

const lastReloadKey = 'chunkLoadErrorReloadedAt';
// Has to outlast a reload plus webpack's chunk load timeout of 2 minutes, otherwise a broken chunk keeps reloading
const reloadCooldownMs = 3 * 60 * 1000;

// A tab that is still running an older build can fail to load its lazy chunks, for example after a deploy or a
// network hiccup. Reloading on the target url fetches the current build, the cooldown prevents a reload loop.
export function reloadOnChunkLoadError(event: NavigationError): void {
  if (!isChunkLoadError(event.error)) {
    return;
  }

  const window = inject(WindowProvider).get();
  const now = Date.now();

  try {
    const lastReload = Number(window.sessionStorage.getItem(lastReloadKey));
    if (now - lastReload < reloadCooldownMs) {
      return;
    }
    window.sessionStorage.setItem(lastReloadKey, String(now));
  } catch {
    // Without sessionStorage there is no way to prevent a reload loop
    return;
  }

  window.location.assign(event.url);
}

function isChunkLoadError(error: any): boolean {
  return error?.name === 'ChunkLoadError' || /Loading chunk [\w-]+ failed/.test(error?.message);
}
